export var DEFAULT_APPEARANCE = 'normal';